import { ROLE_SUPPORT } from "./constants"
import {
  LOCAL_ACTIVE_ROL,
  LOCAL_MODULES,
  LOCAL_TOKEN,
  LOCAL_TRIAL_ACTIVE,
  LOCAL_TRIAL_DURATION,
  LOCAL_TRIAL_MAX_COLLABORATORS,
  LOCAL_TRIAL_START_DATE,
  LOCAL_TWO_FACTOR_AUTH_PENDING,
  LOCAL_USER_ROLES
} from "./storage"

/* eslint-disable prettier/prettier */
import moment from "moment"

export const generateTree = (
  id,
  id_parent,
  arr,
  attr = "childs",
  checkChildren = true
) => {
  const tree = []
  const mappedArr = {}
  let arrElem
  let mappedElem

  for (let i = 0, len = arr.length; i < len; i++) {
    arrElem = arr[i]
    mappedArr[arrElem[id]] = arrElem
    mappedArr[arrElem[id]][attr] = []
  }
  for (var id in mappedArr) {
    if (mappedArr.hasOwnProperty(id)) {
      mappedElem = mappedArr[id]

      if (mappedElem[id_parent]) {
        if (mappedArr[mappedElem[id_parent]]) {
          mappedArr[mappedElem[id_parent]][attr].push(mappedElem)
        } else {
          tree.push(mappedElem)
        }
      } else {
        tree.push(mappedElem)
      }
    }
  }
  if (checkChildren) {
    checkChilds(tree)
  }
  return tree
}

const checkChilds = (tree) => {
  tree.forEach((element) => {
    if (element.childs.length === 0) {
      delete element.childs
    } else {
      checkChilds(element.childs)
    }
  })
}

export const addLevel = (d, childs = "childs") => (o) => {
  o.level = d
  ;(o[childs] || []).forEach(addLevel(d + 1, childs))
}

export const copyToClipboard = (text) => {
  if (window.clipboardData && window.clipboardData.setData) {
    // IE specific code path to prevent textarea being shown while dialog is visible.
    return clipboardData.setData("Text", text)
  }
  if (
    document.queryCommandSupported &&
    document.queryCommandSupported("copy")
  ) {
    const textarea = document.createElement("textarea")
    textarea.textContent = text
    textarea.style.position = "fixed" // Prevent scrolling to bottom of page in MS Edge.
    document.body.appendChild(textarea)
    textarea.select()
    try {
      return document.execCommand("copy") // Security exception may be thrown by some browsers.
    } catch (ex) {
      console.warn("Copy to clipboard failed.", ex)
      return false
    } finally {
      document.body.removeChild(textarea)
    }
  }
}

window.validRole = (params) => {
  const search = (o, id) => {
    if (o.alias === id) {
      return o
    }
    let result
    let p
    for (p in o) {
      if (o.hasOwnProperty(p) && typeof o[p] === "object") {
        result = search(o[p], id)
        if (result) {
          return result
        }
      }
    }
    return result
  }

  if ( (!LOCAL_TOKEN() || !LOCAL_ACTIVE_ROL()) && !LOCAL_TWO_FACTOR_AUTH_PENDING() ) return false

  let validationRole
  let validationModule

  if (params.role) {
    const id_role = parseInt(LOCAL_ACTIVE_ROL())
    const userRoles = JSON.parse(LOCAL_USER_ROLES())
    const hasSupport =  params.role.some(role => role === ROLE_SUPPORT)
    validationRole =hasSupport? userRoles.some(role => role.id === ROLE_SUPPORT): params.role.includes(id_role)
  }

  if (params.module) {
    const modules = JSON.parse(LOCAL_MODULES())
    const validateModule = modules && search(modules, params.module)
    if (validateModule) {
      validationModule = validateModule.accesses_name.includes(params.access)
    }
  }

  if (params.role && params.module) return validationRole && validationModule
  if (params.role) return validationRole
  if (params.module) return validationModule

  return false
}

window.plural = (str, cantidad, sufijo) => {
  if (cantidad == 0) {
    return str + sufijo
  }
  if (cantidad > 1) {
    return str + sufijo
  }
  return str
}

window.pad = (number, length) => {
  let str = `${number}`
  while (str.length < length) {
    str = `0${str}`
  }
  return str
}

// eslint-disable-next-line no-extend-native
String.prototype.format = function () {
  const args = arguments
  return this.replace(/\{(\d+)\}/g, function () {
    return args[arguments[1]]
  })
}

window.formLabelMessage = (lang, field, arg = {}) => {
  const message = window.formLabel[lang][field]
  return message.format(
    Object.keys(arg)
      .map((k) => {
        return arg[k]
      })
      .join(",")
  )
}

window.formLabel = {
  es: {
    required: "Campo obligatorio",
    email_valid: "El correo electrónico no es válido.",
    min: "Se necesita un mínimo de {0} caracteres",
    len: "El campo debe contener {0} caracteres",
    max: "Se necesita un máximo de {0} caracteres",
  },
}

window.sorterBy = (items, key, type) => {
  const compareValues = (key, order = "asc") => {
    return (a, b) => {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        return 0
      }

      const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key]
      const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key]

      let comparison = 0
      if (varA > varB) {
        comparison = 1
      } else if (varA < varB) {
        comparison = -1
      }
      return order == "desc" ? comparison * -1 : comparison
    }
  }

  return items.sort(compareValues(key, type))
}

window.overflowTreeSelect = (className) => {
  const selector = document.querySelector(
    `${className} .ant-select-selection--multiple`
  )
  const element = document.querySelector(
    `${className} .ant-select-selection--multiple .ant-select-selection__rendered`
  )
  if (element) {
    element.scrollTop = element.scrollHeight
  }
  if (selector) {
    if (selector.offsetHeight >= 56) {
      element.style.overflowY = "auto"
      element.style.marginBottom = "0px"
    } else {
      element.style.overflowY = "unset"
      element.style.marginBottom = "-3px"
    }
  }
}

window.queryString = (url) => {
  const arr = url.slice(1).split(/&|=/) // remove the "?", "&" and "="
  const params = {}

  for (let i = 0; i < arr.length; i += 2) {
    const key = arr[i]
    const value = arr[i + 1]
    params[key] = value // build the object = { limit: "10", page:"1", status:"APPROVED" }
  }
  return params
}

window.freemium = () => {
  const isFreemium = LOCAL_TRIAL_ACTIVE() == "true"
  if (!isFreemium) {
    return false
  }
  const setToInitialDay = (t) => {
    return t.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
  }
  const trial_start_date = LOCAL_TRIAL_START_DATE()
  const trial_duration = parseInt(LOCAL_TRIAL_DURATION(), 10)
  const daysRemaining = moment(trial_start_date).isValid()
    ? setToInitialDay(moment(trial_start_date))
        .add(trial_duration, "days")
        .diff(setToInitialDay(moment()), "days")
    : 0
  return {
    isFreemium,
    date: LOCAL_TRIAL_START_DATE(),
    daysRemaining,
    maxEmployees: parseInt(LOCAL_TRIAL_MAX_COLLABORATORS()),
  }
}

window.idActiveRol = () => {
  return parseInt(LOCAL_ACTIVE_ROL())
}

window.getUniqueListBy = (values, key) => {
  return [...new Map(values.map((item) => [item[key], item])).values()]
}
window.slug=(str)=> {
  return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
}
